import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

import modules from './modules';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'testing';

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules,
  strict: debug,
  plugins: debug ? [createLogger()] : []
});
